"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFunnelCurve = void 0;
var _step = require("./step");
var _linear = require("./linear");
var _bump = require("./bump");
var _pyramid = require("./pyramid");
var _stepPyramid = require("./step-pyramid");
const curveConstructor = curve => {
  if (curve === 'step') {
    return _step.Step;
  }
  if (curve === 'bump') {
    return _bump.Bump;
  }
  if (curve === 'pyramid') {
    return _pyramid.Pyramid;
  }
  if (curve === 'step-pyramid') {
    return _stepPyramid.StepPyramid;
  }
  return _linear.Linear;
};
const getFunnelCurve = (curve, options) => {
  return context => new (curveConstructor(curve))(context, options);
};
exports.getFunnelCurve = getFunnelCurve;